import { stringToDate, isValidDate } from './stringToDate';
export const getOptionByValue = (options, value) => {
    if (Array.isArray(value) || value === undefined || value === null) {
        return null;
    }
    if (isValidDate(value)) {
        return options.find((o) => o.value.getTime() === value.getTime());
    }
    if (typeof value === 'string') {
        return options.find((o) => { var _a; return o.value.getTime() === ((_a = stringToDate(value)) === null || _a === void 0 ? void 0 : _a.getTime()); });
    }
    return null;
};
//# sourceMappingURL=getOptionByValue.js.map